import { render } from "./EditarFicherosModal.vue?vue&type=template&id=2c559e14"
import script from "./EditarFicherosModal.vue?vue&type=script&lang=js"
export * from "./EditarFicherosModal.vue?vue&type=script&lang=js"

import "./EditarFicherosModal.vue?vue&type=style&index=0&id=2c559e14&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__